<template>
    <g-level>
        <g-level-item>
            <g-typography :value="title" font-weight="semibold" text-overflow="ellipsis"/>
        </g-level-item>
    </g-level>
</template>

<script>
    export default {
        name: "TitleBar",
        props: {
            title: {
                type: String,
                required: true,
            },
        },
    }
</script>

